import { useEffect, useState } from 'react';

import { getUserTag } from '@/services/user';
import { useUserStore } from '@/store/useUser';

export enum Resident {
  AUT = 'AUT',
  'P-AUT' = 'P-AUT',
  'AUT-PROCESSING' = 'AUT-PROCESSING',
  'AUT-NEW' = 'AUT-NEW',
  'AUT-OUT' = 'AUT-OUT',
  default = 'default',
}

const useTaxJurisdiction = () => {
  const [resident, setResident] = useState(Resident.default);
  const { queryUserTags } = useUserStore();

  const fetchTaxResident = (forceUpdate = false) => {
    queryUserTags(['tax_resident'], forceUpdate).then(
      (res: { [key: string]: any }) => {
        setResident(res.tax_resident || Resident.default);
      },
    );
  };

  const forceUpdateTaxResident = () => {
    fetchTaxResident(true);
  };

  useEffect(() => {
    fetchTaxResident();
  }, []);

  return {
    resident,
    fetchTaxResident,
    forceUpdateTaxResident,
  };
};

export default useTaxJurisdiction;
